import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import { detectIE } from 'lib/helpers';
import { initSvgAnim } from 'lib/bodymovin-helpers';
import checkmarkHeavyAnimData from 'lib/animation-data/checkmark-heavy-animation-data';

export default class PostPurchaseBannerController extends Controller {
  static targets = ['animContainer']

  connect() {
    if (Cookies.get('from_successful_checkout')) {
      Cookies.remove('from_successful_checkout');
    }

    this.readyToPlay = true;

    if (!this.animContainerTarget.querySelector('svg')) {
      initSvgAnim(
        this.animContainerTarget,
        JSON.parse(checkmarkHeavyAnimData),
        false, true,
      );
    }

    if (detectIE() !== false) {
      window.addEventListener('resize', this.resizeHero);

      setTimeout(this.resizeHero(), 300);
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeHero);
  }

   resizeHero = () => {
     const thisSvg = this.animContainerTarget.querySelector('svg');

     const width = this.animContainerTarget.clientWidth;
     const height = width; /* 1:1 square */

     this.animContainerTarget.style.height = `${height}px`;
     thisSvg.style.height = `${height}px`;
   };

   close() {
     this.element.classList.add('is-collapsed');

     setTimeout(() => {
       this.element.remove();
     }, 1500);
   }
}
